<template>
  <section class="container d-flex flex-column mt-3">
    <header>
      <span class="h6">
        <router-link to="/">Início</router-link>
        / Gerador de Campo e Personagens
      </span>

      <h3 class="text-center my-5">
        Gerador de Campo e Personagens
      </h3>
    </header>

    <div class="input-group my-5">
      <select class="form-control form-control-lg" v-model="field.type">
        <option value="small">Pequeno</option>
        <option value="medium">Médio</option>
        <option value="large">Grande</option>
      </select>
      <div class="input-group-append">
        <button
          type="button"
          class="btn btn-lg btn-success"
          @click="generateField"
        >
          Gerar Campo
        </button>
      </div>
    </div>
    <field-table v-if="field.time !== null" :field="field" />

    <div class="input-group my-5">
      <input
        type="text"
        placeholder="Nome do personagem"
        class="form-control form-control-lg"
        v-model="character.name"
      />
      <div class="input-group-append">
        <button
          type="button"
          class="btn btn-lg btn-success"
          :disabled="character.name.length === 0"
          @click="generateCharacter"
        >
          Gerar Personagem
        </button>
      </div>
    </div>
    <character-table v-if="character.race !== null" :character="character" />
  </section>
</template>

<script>
import FieldTable from '../components/FieldTable'
import CharacterTable from '../components/CharacterTable'

import { times, weathers } from '../data/field'
import { races, raceLevels } from '../data/races'
import { classes, classLevels } from '../data/classes'
import primaryWeapons from '../data/primary_weapons'
import secondaryWeapons from '../data/secondary_weapons'
import armors from '../data/armors'
import accessories from '../data/accessories'

import { getRandom } from '../utils/randomPicker'

export default {
  name: 'generator',

  data: () => ({
    field: { type: 'small', time: null, weather: null },
    character: {
      name: '',
      race: null,
      class: null,
      raceLevel: null,
      classLevel: null,
      primaryWeapon: null,
      secondaryWeapon: null,
      armor: null,
      accessory: null
    }
  }),

  components: { FieldTable, CharacterTable },

  methods: {
    generateField() {
      this.field.time = null

      window.setTimeout(() => {
        this.field = {
          ...this.field,
          time: getRandom(times),
          weather: getRandom(weathers)
        }
      }, 1000)
    },

    generateCharacter() {
      this.character.race = null

      window.setTimeout(() => {
        this.character = {
          ...this.character,
          race: getRandom(races),
          class: getRandom(classes),
          raceLevel: getRandom(raceLevels),
          classLevel: getRandom(classLevels)
        }

        this.character.primaryWeapon = getRandom(
          primaryWeapons[this.character.class.slug]
        )
        this.character.secondaryWeapon = getRandom(
          secondaryWeapons[this.character.class.slug]
        )
        this.character.armor = getRandom(armors[this.character.class.slug])
        this.character.accessory = getRandom(
          accessories[this.character.class.slug]
        )
      }, 1000)
    }
  },

  watch: {
    'field.type': {
      handler: function(newVal) { // eslint-disable-line
        this.field.time = null
      }
    }
  }
}
</script>
